import { ButtonColors, DeleteButton, DeleteButtonProps } from '@workday/canvas-kit-react/button';
import { createComponent } from '@workday/canvas-kit-react/common';
import { WcpStyles } from '@workday/wcp-tokens';

export type { DeleteButtonProps } from '@workday/canvas-kit-react/button';

// Unlike the other buttons, wcp-cargo-react has no `deleteButtonColors` helper, so the colors are
// defined here. The critical WcpStyles tokens are theme-aware, so light/dark contrast — including
// the disabled label — is resolved by the tokens themselves and needs no per-theme overrides.
const deleteButtonColors: ButtonColors = {
  default: {
    background: WcpStyles.color.bg.critical.default,
    label: WcpStyles.color.text.inverse,
    icon: WcpStyles.color.text.inverse,
  },
  focus: {
    background: WcpStyles.color.bg.critical.default,
    label: WcpStyles.color.text.inverse,
    icon: WcpStyles.color.text.inverse,
  },
  hover: {
    background: WcpStyles.color.bg.critical.strong,
    label: WcpStyles.color.text.inverse,
    icon: WcpStyles.color.text.inverse,
  },
  active: {
    background: WcpStyles.color.bg.critical.stronger,
    label: WcpStyles.color.text.inverse,
    icon: WcpStyles.color.text.inverse,
  },
  disabled: {
    background: WcpStyles.color.bg.critical.default,
    label: WcpStyles.color.text.inverse,
    icon: WcpStyles.color.text.inverse,
    opacity: '40%',
  },
};

export const ThemedDeleteButton = createComponent('button')({
  displayName: 'ThemedDeleteButton',
  Component: (props: DeleteButtonProps, ref, Element) => (
    <DeleteButton ref={ref} as={Element} colors={deleteButtonColors} {...props} />
  ),
});
